import { css } from '@emotion/core'

export default {
  list: (isMobile) => css`
    // this is a temporary solution
    // this fixes an issue where the date takes up the whole line and makes the record type unreadable
    // we're currently redesigning the date list to fix various issues
    p:has([data-date-list]) {
      max-width: ${isMobile ? '40vw' : '150px'};
      margin-top: 4px;
      text-align: end;
      padding-inline-start: 18px;
    }
  `,
  recordType: (isMobile) => css`
    width: 100%;
    max-width: ${isMobile ? '40vw' : '150px'};
    text-align: start;
  `,
}
